module.exports = "/_next/static/resources/cca-wide-33e3a041947379ab7a757d3934762b23.webp";